export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-minimizer/index.ts